module.exports = __webpack_public_path__ + "img/phone-6064855_1280.23f1f9d6.webp";